// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"475":"ef89e4b8","580":"86c65591"}[chunkId] + ".chunk.css";
};